import { Unchecked, UserSubscription } from '.';

export const getPriceForUserSubscription = (
  userSubscription: UserSubscription,
  intervalOption: SubscriptionIntervalOptions,
  currency: CurrenciesAvailable,
): string => {
  if (userSubscription === UserSubscription.Premium) {
    switch (intervalOption) {
      case SubscriptionIntervalOptions.OneMonth:
        if (currency === CurrenciesAvailable.EUR) {
          return '9.99';
        } else if (currency === CurrenciesAvailable.USD) {
          return '11.99';
        }
        break;
      case SubscriptionIntervalOptions.SixMonths:
        if (currency === CurrenciesAvailable.EUR) {
          return '49.00';
        } else if (currency === CurrenciesAvailable.USD) {
          return '59.00';
        }
        break;
      case SubscriptionIntervalOptions.OneYear:
        if (currency === CurrenciesAvailable.EUR) {
          return '89.00';
        } else if (currency === CurrenciesAvailable.USD) {
          return '99.00';
        }
        break;
    }
  }

  return '0.00';
};

// currency codes according to https://en.wikipedia.org/wiki/ISO_4217
export enum CurrenciesAvailable {
  EUR = 'EUR',
  USD = 'USD',
}

// interval options for extending a subscription in days
export enum SubscriptionIntervalOptions {
  Unknown = 0,
  OneMonth = 30,
  SixMonths = 180,
  OneYear = 365,
}

export interface SubscriptionOverviewItem {
  subscription: UserSubscription;
  intervalInDays: SubscriptionIntervalOptions;
  price: string;
  currency: CurrenciesAvailable;
}

export interface SubscriptionOverview {
  subscriptionOverview: SubscriptionOverviewItem[];
}

export interface CreateSubscriptionRequest {
  subscription: UserSubscription;
  subscriptionInterval: SubscriptionIntervalOptions;
}

export interface CreateSubscriptionResponse {
  message: string;
  redirectUrl: string;
}

export const isPaymentCreateSubscriptionRequest = (
  uncheckedReq?: Unchecked<CreateSubscriptionRequest>,
): uncheckedReq is CreateSubscriptionRequest => {
  const typedReq = uncheckedReq as CreateSubscriptionRequest | undefined;
  return (
    typedReq !== undefined &&
    typedReq !== null &&
    typeof typedReq === 'object' &&
    Object.values(UserSubscription).includes(typedReq.subscription) &&
    Object.values(SubscriptionIntervalOptions).includes(typedReq.subscriptionInterval)
  );
};

export interface DeleteSubscriptionRequest {
  subscription: UserSubscription;
}

export const isPaymentDeleteSubscriptionRequest = (
  uncheckedReq?: Unchecked<DeleteSubscriptionRequest>,
): uncheckedReq is DeleteSubscriptionRequest => {
  const typedReq = uncheckedReq as DeleteSubscriptionRequest | undefined;
  return (
    typedReq !== undefined &&
    typedReq !== null &&
    typeof typedReq === 'object' &&
    Object.values(UserSubscription).includes(typedReq.subscription)
  );
};
